export const ShowSeasonDetails = {
    general: {
        "production_entity": "warner Bro's distribution",
        "mpm": 325435,
        "show_type": "TV",
        "network": "Show Time",
        "time": "9.00 PM - 10.00 PM (1 Hour)",
        "notes": "Initial Rights are locked as of season 4 at $5K perp or $8k AMXT. Option 1 is always MDN and Downloading in perp is locked at $4k. Home Video options are as follows: $6K 15/16, $7K 16/17, $7500 17/18 and beyond.",
        "options": [{ "name": "Music Replaced", "checked": false },
        { "name": "Create Excel w/batch", "checked": true },
        { "name": "Override CostSheet-MS", "checked": false },
        { "name": "Seperate HV Checks/Batch", "checked": false }]
    },
    contacts: {
        "production_exec": "Sue palladino",
        "clearance_rep": "Robert bejowxz",
        "Estimating_manager": "None",
        "cl_rep_assistant": "george stephen",
        "estimater": "John Bejowex"
    },
    default_rights: {
        "initial_rights": "ALL MEDIA 06/07 X-HV",
        "term": "Perp",
        "territory": "WW",
        clearance_budget: [{
            "cost_center": "4648-initial",
            "budget": "$00000000",
            "total_budget": "$00000000",
            "music_amort_code": "None",
            "series_amort": "T7438563"
        }, {
            "cost_center": "4648-Perp",
            "budget": "$0000000",
            "total_budget": "",
            "music_amort_code": "None",
            "series_amort": ""
        }]
    }
}

export const EpisodeCostConfig = {
    cost: null,
    description: null,


}

export const EpisodeListConfig = {
    headings: [
        {
            headingLabel: "#",
            icon: "",
            width: "2%"
        },
        {
            headingLabel: "Episode #",
            icon: "",
            inputType: "text",
            width: "6%",
            dataNode: "episode_number"
        },
        {
            headingLabel: "Title",
            icon: "",
            width: "6%",
            inputType: "text",
        },
        {
            headingLabel: "Air Date",
            inputType: "datefield",
            icon: "",
            width: "5.5%"
        },
        {
            headingLabel: "EFC",
            icon: "",
            width: "7%"
        },
        {
            headingLabel: "BCH",
            icon: "payment",
            width: "7%"
        },
        {
            headingLabel: "CS",
            icon: "",
            width: "7%",
        },
        {
            headingLabel: "Main Title",
            icon: "",
            width: "5%",
            inputType: "text"
        },
        {
            headingLabel: "Mix Date",
            icon: "",
            width: "6%",
            inputType: "datefield",
        },
        {
            headingLabel: "NoMT?",
            icon: "",
            width: "4%",
        },
        {
            headingLabel: "BdgtDiff?",
            icon: "",
            width: "5%",
            inputType: "checkbox"
        },
        {
            headingLabel: "Ngtd.4646",
            icon: "",
            width: "6%",
            inputType: "text"
        }, {
            headingLabel: "Ngtd.4675",
            icon: "",
            width: "6%",
            inputType: "text"
        },{
            headingLabel: "Ngtd Budget",
            icon: "",
            width: "4%",
            inputType: "text"
        }, {
            headingLabel: "Ngtd New",
            icon: "",
            width: "3.5%"
        },
        {
            headingLabel: "Ep.Costs",
            icon: "",
            width: "5%"
        },
        {
            headingLabel: "Notes",
            icon: "",
            width: "4%"
        },
        {
            headingLabel: "Cmplt",
            icon: "",
            width: "4%"
        },
        {
            headingLabel: "No Lic. Music",
            icon: "",
            width: "4%"
        },  
    ],
    primaryKey: "show_season_episode_id",
    dataNodes: ["index", "episode_number", "episode_title", "air_date", "efc_run_date", "bch_latest_date", "cue_sheet_revision_send_date", "main_title", "mixed_date","is_no_mt","is_budget_difference", "ngtd_4646","ngtd_4675", "episode_negotiated_costs", "is_ngtd_new", "episode_cost", "notes", "is_completed", "is_no_lincensed_music"],
    actions: ["pen", "times"],
    nodeFields: [
        {
            column: "episode_cost",
            icon: "file"
        },
        {
            column: "episode_negotiated_costs",
            icon: "file"
        },
        {
            column: "notes",
            icon: "file"
        },
        // {
        //     column: " ",
        //     icon: "flag"
        // },
        {
            column: "is_ngtd_new",
            icon: "check"
        },
        {
            column: "is_no_mt",
            icon: "check"
        },
        {
            column: "is_budget_difference",
            icon: "check"
        },
        {
            column: "is_completed",
            icon: "check"
        },
        {
            column: "is_no_lincensed_music",
            icon: "check"
        },
    ],

    primaryKey: "id",
    // toggleFields: ["is_ngtd_new", "is_budget_difference", "is_completed"],
    buttonFields: [{ column: "efc_run_date", icon: "", showDataNodeValue: true},{ column: "bch_latest_date", icon: "", showDataNodeValue: true}, { column: "cue_sheet_revision_send_date", icon: " ", showDataNodeValue: true }],
    hyperlinks: ["episode_number"],
    inlineEdits: [
        {
            dataNode: "index",
            width: "5%"
        },
        {
            dataNode: "episode_number",
            width:"6%"
        },
        {
            dataNode: "episode_title",
            width:"6%"
        },
        {
            dataNode: "air_date",
            width:"7%"
        },
        {
            dataNode: "efc_run_date",
            width:"4%"
        },
        {
            dataNode: "bch_latest_date",
            width:"4%"
        },
        {
            dataNode: "cue_sheet_revision_send_date",
            width:'8%'
        },
        {
            dataNode: "main_title",
            width:'6%'
        },
        {
            dataNode: "mixed_date",
            width:'6%'
        },
        {
            dataNode: "is_no_mt",
            width:'4%'
        },
        {
            dataNode: "is_budget_difference",
            width:'6%'
        },
        {
            dataNode: "ngtd_4646",
            width: '6%',
            inlineIcon:"$"
        },{
            dataNode: "ngtd_4675",
            width: '6%',
            inlineIcon:"$"
        },
        {
            dataNode: "episode_negotiated_costs",
            width:'8%'
        },
        {
            dataNode: "is_ngtd_new",
            width:'6%'
        },
        {
            dataNode: "episode_cost",
            width: '5%'
        },
        {
            dataNode: "notes",
            width: '4%'
        },
        {
            dataNode: "is_completed",
            width: '4%'
        }

    ]
};
export const PopoverOptions = [
    {
        title: "All Media 06/07 X-HV",
        name: "Perp",
        value: "$852,050.00"
    },
    {
        title: "All Media 06/07 X-THEA",
        name: "Perp",
        value: "$852,050.00"
    },
    {
        title: "6 Yr HOME VIDEO 06/07",
        name: "Perp",
        value: "$852,050.00"
    },
]
export const InfoPopoverOptions = [
    {
        title: "Default Alt Initial",
        name: "[Rights]",
        value: "[Term], [Territory]"
    },
    {
        title: "Default Option",
        name: "6 YRS HOME VIDEO 06/07",
        value: "1 year, WW"
    },
    {
        title: "Default Option",
        name: "[Rights]",
        value: "[Term], [Territory]"
    },
]
export const PopoverReportOptions = [
    {
        label: "Main Title Report",
        value: "mainTitleReport",
        permissionName : 'Main Title Report',
    },
    {
        label: "Mix Date Report",
        value: "mixDateReport",
        permissionName : 'Mix Date report',
    },
    {
        label: "Music Replacement Report",
        value: "musicReplacementReport",
        permissionName : 'Music Replacement report',
    },
    {
        label: "Show Season Song/Cost To Date",
        value: "showSeasonSongCostToDate",
        permissionName : 'Show Season Song/Cost To Date report',
    },
    {
        label: "Budget vs EFC",
        value: "budgetvsEFCbyEpisode",
        permissionName : 'Budget vs. EFC by Episode report',
    },
]
export const FilePopoverOptions = [
    {
        label: "No MT",
        checked: false
    },
    {
        label: "Budget Difference",
        checked: false
    },
    {
        label: "Music Replaced",
        checked: false
    }, {
        label: "Excl. from Bdgt/EFC Report",
        checked: false
    }, {
        label: "Mixed",
        checked: false
    },
]

/** Defaults for Tree View rights filters (Show Season → Tree). Mirrors `usp_dashboard_rights_get` flags. */
export const defaultTreeViewRightsFilters = {
    usingSongsOnly: true,
    completedEpsOnly: false,
    coaOnly: false,
    excludeCoa: false,
    /** Legacy SQL Server @INCINTERIOR: include episodic clearance branch (not “interior music use”). */
    includeInterior: true,
    includeMainTitle: false,
    /** '' = all; otherwise one of S, M, SM, G (cli.licensor_type) */
    licensorType: '',
    whvCmpltOnly: false,
    msCmpltOnly: false,
    limitMusicCost: false,
    libraryOnly: false,
    excludeLibrary: false,
    excludePromo: true};

/** Map UI state to API payload (1/0 for reliable JSON_EXTRACT in MySQL). */
export function applyTreeViewRightsFiltersToPayload(mockJSON, filters) {
    if (!mockJSON || !filters) return;
    mockJSON.tree_filter_using_songs_only = filters.usingSongsOnly ? 1 : 0;
    mockJSON.tree_filter_completed_eps_only = filters.completedEpsOnly ? 1 : 0;
    mockJSON.tree_filter_coa_only = filters.coaOnly ? 1 : 0;
    mockJSON.tree_filter_exclude_coa = filters.excludeCoa ? 1 : 0;
    /* Maps to p_TreeCL @INCINTERIOR: 1 = include episodic clearance branch */
    mockJSON.tree_filter_include_interior = filters.includeInterior !== false ? 1 : 0;
    mockJSON.tree_filter_include_main_title = filters.includeMainTitle !== false ? 1 : 0;
    const allowedLt = ['S', 'M', 'SM', 'G'];
    mockJSON.tree_filter_licensor_type = allowedLt.includes(filters.licensorType) ? filters.licensorType : null;
    mockJSON.tree_filter_whv_cmplt_only = filters.whvCmpltOnly ? 1 : 0;
    mockJSON.tree_filter_ms_cmplt_only = filters.msCmpltOnly ? 1 : 0;
    mockJSON.tree_filter_limit_music_cost = filters.limitMusicCost ? 1 : 0;
    mockJSON.tree_filter_library_only = filters.libraryOnly ? 1 : 0;
    mockJSON.tree_filter_exclude_library = filters.excludeLibrary ? 1 : 0;
    mockJSON.tree_filter_exclude_promo = filters.excludePromo ? 1 : 0;
}

export const rightsRecordJson = { 
    right_type_search_ids:null,
    licensor_search_ids:null,
    expiring_search_ids:null,
    term_search_ids:null,
    territory_search_ids:null,
    opt_expire_search_ids:null,
    expire_date_search_text:null,
    acquired_search_flag:null,
    show_search_ids:null,
    season_search_ids: null,
    show_year_search_text:null,
    episode_title_search_text:null,
    episode_no_search_text:null,
    /** Tree View: use SP composite order (see usp_dashboard_rights_get order_by_clause = Tree). */
    order_by_clause: "Tree",
    order_by: null,
    page_count: 25,
    page_no:1,
    pagination: false,
    all_seasons: false,
    /** Tree View: `season` (default) or `program` (group by show/program first). Ignored by Dashboard grid. */
    tree_group_by: "season",
    /** When all_seasons is true: narrow result set 1 (detail) to this show; null = omit. */
    tree_detail_show_id: null,
    /** When all_seasons is true: optional; null = all seasons under tree_detail_show_id. */
    tree_detail_season_id: null,
    tree_filter_using_songs_only: 0,
    tree_filter_completed_eps_only: 0,
    tree_filter_coa_only: 0,
    tree_filter_exclude_coa: 0,
    tree_filter_include_interior: 1,
    tree_filter_include_main_title: 1,
    tree_filter_licensor_type: null,
    tree_filter_whv_cmplt_only: 0,
    tree_filter_ms_cmplt_only: 0,
    tree_filter_limit_music_cost: 0,
    tree_filter_library_only: 0,
    tree_filter_exclude_library: 0,
    tree_filter_exclude_promo: 0
}
